import Constant from '@/const'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 登録
    async post({ commit, dispatch }, data) {
      const request = {
        params: data,
        url: Constant.API_URL.TMP_TORIHIKI,
        error: { message: '仮取引マスタの登録に失敗しました。' },
      }
      await dispatch('http/post', { ...request }, { root: true })
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/tmpTorihiki.js